import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AUTH } from "@/constants/testIds";
import { AuthScaffold } from "@/pages/auth/Login";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await forgotPassword(email.trim());
    setBusy(false);
    setMessage(res.ok ? (res.data?.message || "Check your email.") : res.error);
  };

  return (
    <AuthScaffold>
      <form onSubmit={onSubmit} data-testid={AUTH.forgotForm} className="space-y-5">
        <div className="space-y-1">
          <div className="eyebrow">Reset access</div>
          <h1 className="font-anton text-4xl sm:text-5xl uppercase leading-none">Forgot password</h1>
          <p className="text-lifted-dim text-sm">Enter your email and we'll prepare a reset link.</p>
        </div>

        <div>
          <label className="lifted-label">Email</label>
          <input
            type="email" required className="input-lifted"
            value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid={AUTH.forgotEmail}
            placeholder="you@liftedatthemoment.com"
          />
        </div>

        {message && (
          <div data-testid={AUTH.forgotMessage} className="text-sm text-lifted-green bg-lifted-green/5 border border-lifted-green/30 rounded-md px-3 py-2">
            {message}
          </div>
        )}

        <button type="submit" disabled={busy} className="btn-lifted w-full" data-testid={AUTH.forgotSubmit}>
          {busy ? "Sending…" : "Send reset link"}
        </button>

        <div className="pt-2 text-xs text-lifted-dim text-center">
          <Link to="/auth/login" data-testid={AUTH.goLogin} className="text-lifted-green hover:underline font-bebas tracking-widest">
            ← Back to sign in
          </Link>
        </div>
      </form>
    </AuthScaffold>
  );
}
